import { useEffect, useState } from "react";

export type PageTag = "home" | "schedule" | "deadlines" | "map" | "settings";

export function usePageTag(tag?: PageTag): PageTag {
  const [currentTag, setCurrentTag] = useState<PageTag>(() => {
    const path = window.location.pathname;
    if (path === "/" || path === "") return "home";
    if (path === "/schedule") return "schedule";
    if (path === "/deadlines") return "deadlines";
    if (path === "/map") return "map";
    if (path === "/settings") return "settings";
    return "home";
  });

  useEffect(() => {
    const updateTag = () => {
      const path = window.location.pathname;
      let newTag: PageTag = "home";
      if (path === "/" || path === "") newTag = "home";
      else if (path === "/schedule") newTag = "schedule";
      else if (path === "/deadlines") newTag = "deadlines";
      else if (path === "/map") newTag = "map";
      else if (path === "/settings") newTag = "settings";
      setCurrentTag(newTag);
    };

    updateTag();
    window.addEventListener("popstate", updateTag);
    window.addEventListener("app:navigate", updateTag);
    return () => {
      window.removeEventListener("popstate", updateTag);
      window.removeEventListener("app:navigate", updateTag);
    };
  }, []);

  useEffect(() => {
    if (tag) {
      const el = document.documentElement;
      const prev = el.getAttribute("data-page");
      el.setAttribute("data-page", tag);
      return () => {
        if (prev) el.setAttribute("data-page", prev);
        else el.removeAttribute("data-page");
      };
    }
  }, [tag]);

  return tag || currentTag;
}
